import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import {Field, FieldArray, reduxForm} from "redux-form";
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import renderField from "../onboarding/Form";

const styles = {
  flex: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  input: {
    width: '48%',
    marginBottom: 40
  },
  heading: {
    margin: '60px 0',
    textTransform: 'uppercase'
  }
};
const required = value => value ? undefined : "Required";

const Profile = ({classes, pristine, submitting, handleSubmit, saving, saved, resetPassword, resetPasswordEmailSent, initialValues:{ email }}) => {
  return(
  <div>
    <Typography variant="display1" className={classes.heading}>PERSONAL DETAILS</Typography>
    {
          saving === true && <div><i className="fa fa-spinner" aria-hidden="true"/> Saving...</div>
        }
        {
          saved === true &&
          <div className="notification is-primary">
            Saved successfully
          </div>
        }
        {
          resetPasswordEmailSent&&
          <div className="notification is-primary">
            Reset password email sent
          </div>
        }
    <Card>
      <CardContent style={{padding: 50}}>
      <form onSubmit={handleSubmit}>
        <div className={classes.flex}>
          <div className={classes.input}>
            <Field
              component={renderField}
              type="text"
              label="Name"
              name="displayName"
            />
          </div>
          <div className={classes.input}>
            <Field
              component={renderField}
              type="text"
              label="Email Address"
              name="email"
            />
          </div>
        </div>
        <div className={classes.flex}>
          <div className={classes.input}>
            <Field
              component={renderField}
              type="text"
              label="Phone Number"
              name="phone"
            />
          </div>
          <div className={classes.input}>
            <Field
              component={renderField}
              type="text"
              label="Designation"
              name="role"
            />
          </div>
        </div>
        <div className={classes.flex}>
          <div className={classes.input}>
            <Field
              component={renderField}
              disabled
              type="text"
              label="ID"
              name="id"
            />
          </div>
        </div>
        <div className="field is-grouped">
        <div className="control">
            <Button variant="outlined" onClick={() => resetPassword(email)}>
              Reset Password
            </Button>
        </div>
        <div className="control">
          <Button
            type="submit"
            disabled={pristine || submitting}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </div>
      </div>
      </form>
      </CardContent>
    </Card>
  </div>
)}

const ProfileWithForm: any = reduxForm({
  form: "profile", // a unique identifier for this form
})(Profile);

const mapStateToProps: any = ({ auth: {displayName, email, uid, role, phone, charityKey }, charities }) => {
  return {initialValues: 
    {
    displayName,
    email,
    id: charityKey? charities.all[charityKey].charityId: '',
    role,
    phone
  }
  }
}

export default connect(mapStateToProps)(withStyles(styles)(ProfileWithForm));